module.exports = __webpack_public_path__ + "img/notice.072bd4ce.svg";